import { Delete, EditWithoutLine, MoreSettings } from '@shared/assets/icons/components';
import { Text } from '@shared/ui/antd';
import { Flex, Popover } from 'antd';
import type { FC, MouseEvent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './preset-settings.module.scss';

interface PresetSettingsProps {
  onEdit: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

export const PresetSettings: FC<PresetSettingsProps> = ({ onEdit, onDelete, disabled = false }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'presets.table' });
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    if (disabled) return;
    setIsOpen(open);
  };

  const handleAction = (action: () => void) => (event: MouseEvent) => {
    event.stopPropagation();
    setIsOpen(false);
    action();
  };

  const menuItems = [
    { key: 'edit', icon: <EditWithoutLine />, label: t('edit'), action: onEdit },
    { key: 'delete', icon: <Delete />, label: t('delete'), action: onDelete },
  ];

  return (
    <Popover
      content={
        <Flex vertical>
          {menuItems.map((item) => (
            <Flex
              key={item.key}
              align="center"
              gap={8}
              className={styles.menuItem}
              onClick={handleAction(item.action)}
            >
              {item.icon}
              <Text variant="sm" fontWeight={600}>
                {item.label}
              </Text>
            </Flex>
          ))}
        </Flex>
      }
      trigger="click"
      open={disabled ? false : isOpen}
      onOpenChange={handleOpenChange}
      placement="bottomRight"
      arrow={false}
    >
      <Flex
        align="center"
        justify="center"
        className={classNames(styles.trigger, { [styles.disabled]: disabled })}
        onClick={(event) => event.stopPropagation()}
      >
        <MoreSettings />
      </Flex>
    </Popover>
  );
};
